// Pure payload-builder for POST /schedule/create, extracted out of submit()
// so the protein_priority field (and the rest of the payload shape) can be
// unit-tested without rendering the ScheduleBuilder component.
export function buildSchedulePayload({
  name,
  totalMeals,
  timeValue,
  timeMinValue,
  ingredients,
  defaultServings,
  proteinPriority,
  mealTypeCounts,
  lockedRecipes = [],
  dietOverride = null,
}) {
  return {
    title: name.trim() || "My Schedule",
    number_of_recipes: totalMeals,
    max_time_minutes: timeValue,
    // Lower edge of the selected bucket. Sending only the upper edge made
    // "Relaxed 45–60" indistinguishable from "anything up to 60 minutes",
    // which is why that bucket kept returning 20-minute recipes.
    ...(timeMinValue ? { min_time_minutes: timeMinValue } : {}),
    // The feature-ingredient control offers ingredients AND families. They go
    // over separately: a family is sent as its slug and expanded to members on
    // the server, so a recipe ingested after this schedule was built is still
    // reachable by the same word.
    ingredients_wanted: ingredients.filter((i) => i.kind !== "group").map((i) => i.id),
    ingredient_groups_wanted: ingredients.filter((i) => i.kind === "group").map((i) => i.slug),
    goals_wanted: [],
    target_servings: defaultServings,
    protein_priority: proteinPriority,
    ...(mealTypeCounts ? { meal_type_counts: mealTypeCounts } : {}),
    // Recipes picked in the browse catalog. Sent as ids for the backend to seed
    // as locked slots — the builder then fills the rest of the week around them
    // with its normal logic. Always present (an empty array is the no-picks
    // case) so the payload shape doesn't change depending on how you arrived.
    locked_recipe_ids: lockedRecipes.map((r) => r.id),
    // Diet for this build only. OMITTED unless the user actually touched the
    // control — an absent field means "use the profile setting", which is not
    // the same as sending "none". Always sending the control's current value
    // would mean a preferences request that hadn't landed yet got posted as an
    // explicit "no restriction", quietly building a vegetarian a week of meat.
    ...(dietOverride ? { diet_override: dietOverride } : {}),
  };
}
